import React from "react";
import classNames from "classnames";
import Icon from '@mdi/react';
import { MultipleChoiceForm } from "./MultipleChoiceForm.jsx";
import { FormLabel } from "../FormLabel.jsx";
import { FormErrorMessage } from "../FormErrorMessage.jsx";
import isMobile from '../../../../../../utils/isMobile.js';
import {  mdiRadioboxBlank, mdiRadioboxMarked, mdiCheckboxMarked, mdiCheckboxBlankOutline } from '../../../../../../images/svg';

export class CheckBoxForm extends MultipleChoiceForm {
  handleClick(label) {
    const {
      input,
      object: {
        data: { mode },
      },
    } = this.props;
    const value = this.handleMultipleChoice(mode, input, label);
    input.onBlur();
    input.onChange(value);
  }

  render() {
    const {
      disabled,
      input,
      meta,
      object: {
        label,
        validations,
        purpose,
        data: { mode, candidates },
      },
    } = this.props;

    return (
      <div className="cu-ui-form-group">
        <FormLabel
          valid={meta.valid}
          label={label}
          required={validations.required}
          utilText={this.getLabelUtilText(this.props.object, input)}
        />
        <div>
          {_.map(candidates, (button, idx) => {
            const isChecked = this.isSelectedMultipleChoice(
              mode,
              input,
              button.value
            );
            const checkboxClassName = classNames("cu-ui-checkbox-group", {
              disabled: disabled,
              large: isMobile(),
            });
            const icon =
              purpose === "single_choice"
                ? isChecked
                  ? mdiRadioboxMarked
                  : mdiRadioboxBlank
                : isChecked
                  ? mdiCheckboxMarked
                  : mdiCheckboxBlankOutline;
            const color = disabled
              ? '#dcdbd8'
                : isChecked
                  ? "#925DE2"
                  : "#C1C0BE";

            return (
              <div key={idx} className={checkboxClassName}>
                <div onClick={() => this.handleClick(button.value)} tabIndex="0">
                  <Icon
                    size={1}
                    style={{ color }}
                    path={icon}
                  />
                </div>
                <label onClick={() => this.handleClick(button.value)}
                    style={{ marginLeft: '4px' }}>
                  {" "}
                  {button.label}{" "}
                </label>
              </div>
            );
          })}
        </div>
        <FormErrorMessage error={meta.error} touched={meta.touched} />
      </div>
    );
  }
}
